/* sb-tpl-picker.js — the "what are you making?" product picker.
   2026-09-05.

   Two entry points use it:
     - the top bar link this file inserts next to Help Center (every page);
     - the "See All Design Templates" button inside the design center, which
       calls window.__sbTplPicker.show() (see sb-dc-tplbutton.js).

   The gallery holds 700-odd designs across a dozen products. Sending someone
   there cold means scrolling past retractables to find a sticker, so the link
   asks what they are making first and opens the gallery already filtered:
   /pages/design-templates?for=<product>, matched against the gallery's own
   product filter by sb-dc-tplfor.js.

   Always a new tab. On the storefront nobody should lose the product page they
   were reading; in the editor nobody should lose the design in progress, which
   is kept nowhere.

   Styling takes the theme's own variables rather than a palette of its own —
   --font-body-family (Roboto here), --color-button for the navy, --color-
   background for the tint. A restyle of the store carries into this dialog
   instead of leaving it looking like someone else's popup.

   The top bar link: cloned from the Help Center link so it inherits the inner
   <span class="body-small"> that sets the bar's 14.8px — built by hand it came
   out a size larger than its neighbours. It is then coloured amber and bolded,
   which is how it stands out now: same size as the rest of the bar, different
   colour, rather than simply bigger and whiter.

   2026-10-03 (theme "DC tool"): the bar wording changed at the store's request
   from "Free Design Tool" to a main line plus a smaller call to action after
   it. LABEL is the main line, CTA the small one; both sit inside the same link,
   between the two stars, and the whole thing still opens the picker.
   Wording history the same day: the store's "Super easy & fast Design tool. No
   extra charge!" + "Try now" -> two rewrites tried -> back to the store's line.
   Capitalisation, as the store settled it: sentence case, except "Design Tool"
   which is capitalised as the name of the tool (so "Super easy & fast Design
   Tool. No extra charge!").
   To change the words, edit LABEL and CTA only.
   2026-10-04: LABEL is now "Easy & Fast Design Center. No extra charge!" and
   the "Try now" tail is gone (store's request) - CTA and its <small> removed.
   2026-10-03 (2): the store wants it at the true centre of the bar (stars
   included), not starting under «Stickers» — so the V0.0.8 2차 Stickers
   alignment is retired and align() only keeps the CSS centre. guard() still
   slides it left on narrow windows where the centred line would run into the
   phone/email on the right. */
(function () {
  'use strict';

  var LINK_CLASS = 'sb-tplpick-link';
  var LI_CLASS = 'sb-tplpick-li';     // 2026-09-08 V0.0.6: the <li> we add, for centring
  var MODAL_ID = 'sb-tplpick-modal';
  var BASE = '/pages/design-templates';
  /* 2026-10-12 (theme "sticker shipping"): the bar line is no longer the design
     tool. The store asked for the same-day-shipping cut-offs instead, numbers in
     red and the rest in the bar's yellow, stars kept. LINE is the wording in
     pieces: plain strings stay yellow, { n: '...' } pieces are the red numbers.
     LABEL is the same words joined, for aria-label/title. The link now goes to
     the Shipping Details page instead of opening the picker; the picker itself
     is untouched and still opened by the design center's own button.
     Was: 'Easy & Fast Design Center. No extra charge!' (2026-10-04). */
  /* { lead: '...' } is dropped under 1100px wide: the full line is ~515px and
     between ~1025 and 1090px it ran into the phone number on the right. */
  var LINE = [{ lead: 'Same Day Shipping — ' }, 'Ground: Order by ', { n: '4' }, ' PM EST · Express: Order by ', { n: '6' }, ' PM EST'];
  var LABEL = LINE.map(function (p) { return typeof p === 'string' ? p : (p.n || p.lead); }).join('');
  var SHIP_URL = '/pages/shipping-details';
  var ACCENT = '#ffc533';   // amber against the bar's navy
  var NUM_RED = '#ff4848';  // 2026-10-12: the cut-off hours; bright enough to read on the navy
  /* 2026-10-12 (2): a plain click opens SHIP_URL in a popup on the current page
     (store's request) instead of navigating. The popup is this file's own, not
     the homepage blocks' sbpp2/sbpp3 popups, because those only exist on the
     homepage and the bar is on every page. Ctrl/Cmd/Shift/middle click still
     follow the real href, and if the fetch fails the click falls back to it. */
  var SHIP_MODAL_ID = 'sb-shippop';
  var SHIP_TITLE = 'Shipping Details';

  /* label   — what the customer reads
     filter  — what the gallery's product filter calls it, when the two differ.
               sb-dc-tplfor.js matches the filter's own wording exactly first,
               so this must stay spelled as the gallery spells it.
     product — a product handle, sent as ?product= instead of ?for=. Only for
               cards the gallery's filter has no separate option for; see the
               Fabric Step & Repeat note below.
     note    — one line under the name.

     Ordered the way a customer thinks: banners, backdrops, stands, stickers.
     2026-09-05: Mesh Banners, Window Decals / Adhesive and Kiss-Cut Stickers
     removed at the store's request; "Pop-Up Retractable Banner" shortened to
     "Retractable Banner". Everything removed is still reachable through
     "Browse all templates".
     2026-09-06: the X-Banner card reads "X-Banner" only — the store asked for
     the "Double-Sided" half of the wording off the card. It still opens the
     same set: filter keeps the gallery's own longer spelling, and "X-Banner"
     alone is too short for sb-dc-tplfor.js to match on.
     2026-09-08 V0.0.9: the store set the head of the list — Step & Repeat,
     Fabric Step & Repeat, then Custom Vinyl Banners. Everything below keeps
     the order it had.
       "Fabric Step & Repeat" is new, and it is the one card that cannot use
     ?for=. The gallery's filter has ONE step & repeat option covering both
     materials (sections/sb-dc-templates.liquid, PRODUCTS — vinyl and fabric
     handles sit under "Step & Repeat Backdrops"), so ?for= would open the
     right designs but hand the design center the vinyl handle. Sending
     ?product=fabric-step-and-repeat-banner instead lets the gallery read the
     handle itself (sb-dc-handle.js): same step & repeat designs, and the
     fabric product is what the customer ends up designing on.
       So the two cards show the same artwork. That is correct — a logo wall
     design is the same picture on either material; only the product carried
     forward differs. If the store ever wants two distinct sets, that is done
     in the admin panel by tagging designs, not here.
     2026-09-08 (2): Mesh Banners and Window Decals / Adhesive are back on the
     list, and the stickers moved to the bottom with Bumper first (store's
     order). Both new cards use ?for= — the gallery has an option for each
     already. They had no designs of their own, which is why they came off the
     list on 2026-09-05; they now borrow the Custom Vinyl Banners set through
     SHARE in assets/sb-dc-handle.js, and the product page gate in
     snippets/sb-dc-cta.liquid was opened for them in the same pass. If that
     borrow is ever switched off, these two cards land on an empty grid — take
     them out again here at the same time.
     2026-09-12: the four flag shapes and the yard sign join the list, in the
     third row (store's request) — they go in after Window Decals, which at the
     three-column width the dialog renders at puts Feather Angled, Feather
     Convex and Teardrop on row three and Rectangle, Yard Signs and Pop-Up on
     row four.
       All five use ?product=, not ?for=. The gallery's own <select> has no
     option for any of them; sb-dc-tplflags.js adds a "Flags & Signs" group to
     it at runtime and the page itself already filters correctly on a flag
     handle, so the handle is the thing to send. ?for= would fall through
     sb-dc-tplfor.js's word-overlap test onto whatever banner scored highest.
       Each flag shape is a separate product PER SIZE, so a card has to name
     one. The store chose Large. A customer who wants Small changes the size
     in the gallery's product picker or on the product page — the designs are
     the same set either way, since dc_templates tags them by shape family
     (feather-angled, teardrop, ...) and not by size.
       Econo Feather is deliberately not here: the store asked for the four
     shapes. It stays reachable through "Browse all templates" and through the
     gallery's own Flags & Signs group. */
  var ITEMS = [
    { label: 'Step & Repeat Backdrops', note: 'Logo wall for photos' },
    { label: 'Fabric Step & Repeat', product: 'fabric-step-and-repeat-banner', note: 'Logo wall, soft fabric' },
    { label: 'Custom Vinyl Banners', note: 'Outdoor, indoor, any size' },
    { label: 'Fabric Banners', note: 'Soft, no glare' },
    { label: 'Mesh Banners', note: 'Wind passes through' },
    { label: 'Window Decals / Adhesive', note: 'Sticks to glass and walls' },
    { label: 'Feather Angled Flags', product: 'feather-angled-flag-large', note: 'Tall flag, angled top' },
    { label: 'Feather Convex Flags', product: 'feather-convex-flag-large', note: 'Tall flag, curved top' },
    { label: 'Teardrop Flags', product: 'teardrop-flag-large', note: 'Rounded teardrop shape' },
    { label: 'Rectangle Flags', product: 'rectangle-flag-large', note: 'Straight rectangular flag' },
    { label: 'Yard Signs', product: 'yard-sign', note: 'Lawn sign with H-stake' },
    { label: 'Pop-Up Display Backdrop', note: 'Fabric over a frame' },
    { label: 'Retractable Banner', filter: 'Pop-Up Retractable Banner', note: 'Roll-up stand' },
    { label: 'X-Banner', filter: 'X-Banner / Double-Sided X-Banner', note: 'Light, portable stand' },
    { label: 'Bumper Stickers', note: 'Long rectangles' },
    { label: 'Round Stickers', note: 'Die-cut circles' },
    { label: 'Oval Stickers', note: 'Die-cut ovals' }
  ];

  /* Where a card goes. Handles use ?product=, names use ?for= — see ITEMS. */
  function hrefFor(it) {
    return it.product
      ? BASE + '?product=' + encodeURIComponent(it.product)
      : BASE + '?for=' + encodeURIComponent(it.filter || it.label);
  }

  function css() {
    if (document.getElementById('sb-tplpick-css')) return;
    var st = document.createElement('style');
    st.id = 'sb-tplpick-css';
    /* rgb(var(--color-button)) is the theme's navy; the fallbacks keep the
       dialog readable if a page ever loads without the theme's variables — the
       design center layout is one of those.
       The !important on the link colour is not laziness: the bar's own rule
       paints every link in that list 80% white, and it wins on specificity.
       grid-auto-rows:1fr keeps every card the same height: without it a name
       that wraps to two lines makes its whole row taller than the others. */
    st.textContent =
      '.' + LINK_CLASS + ',.' + LINK_CLASS + ' span{color:' + ACCENT + ' !important;font-weight:700 !important}' +
      /* 2026-10-03: the longer wording stays on one line; the CTA is the smaller tail. */
      '.' + LINK_CLASS + '{white-space:nowrap}' +
      /* 2026-09-08 V0.0.6 — desktop bar only (the mobile drawer keeps the plain link).
         V0.0.8: the link sits at the true centre of the bar (store's request), not the centre
         of the gap after Help Center: its <li> leaves the flow and hangs at 50% of the row.
         Twinkle: one star on each side, fixed 14px from the text, same timing. */
      '.header-row-inner--small{position:relative}' +
      '.header-secondary-menu--small .' + LI_CLASS + '{position:absolute;left:50%;top:0;bottom:0;transform:translateX(-50%);display:flex;align-items:center}' +
      '.header-secondary-menu--small .' + LINK_CLASS + '{position:relative;display:inline-block;padding:0 14px}' +
      '.header-secondary-menu--small .' + LINK_CLASS + '::before,.header-secondary-menu--small .' + LINK_CLASS + '::after{' +
      'content:"\\2726";position:absolute;top:50%;margin-top:-5px;font-size:9px;line-height:1;color:#fff59d;' +
      'pointer-events:none;animation:sb-tplpick-tw 2.4s ease-in-out infinite}' +
      '.header-secondary-menu--small .' + LINK_CLASS + '::before{left:0}' +
      '.header-secondary-menu--small .' + LINK_CLASS + '::after{right:0}' +
      /* hover: both stars freeze at their biggest (the 45% keyframe) */
      '.header-secondary-menu--small .' + LINK_CLASS + ':hover::before,.header-secondary-menu--small .' + LINK_CLASS + ':hover::after{' +
      'animation:none;opacity:1;transform:scale(1.15) rotate(90deg)}' +
      '@keyframes sb-tplpick-tw{0%,100%{opacity:.15;transform:scale(.7) rotate(0)}' +
      '45%{opacity:1;transform:scale(1.15) rotate(90deg)}60%{opacity:.35;transform:scale(.9) rotate(120deg)}}' +
      '@media (prefers-reduced-motion:reduce){.' + LINK_CLASS + '::before,.' + LINK_CLASS + '::after{animation:none;opacity:1}}' +
      '.' + LINK_CLASS + ':hover,.' + LINK_CLASS + ':hover span{color:#ffd873 !important}' +
      /* 2026-10-12: the cut-off hours stay red, hover included */
      '.' + LINK_CLASS + ' .sb-tp-num,.' + LINK_CLASS + ':hover .sb-tp-num{color:' + NUM_RED + ' !important;font-weight:800 !important}' +
      '@media (max-width:1099px){.' + LINK_CLASS + ' .sb-tp-lead{display:none}}' +
      /* 2026-10-12 (2): the Shipping Details popup */
      '#' + SHIP_MODAL_ID + '{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;' +
      'justify-content:center;padding:20px;background:rgba(7,39,71,.6)}' +
      '#' + SHIP_MODAL_ID + ' .sb-sp-box{background:#fff;width:min(1100px,96vw);height:90vh;border-radius:14px;' +
      'overflow:hidden;display:flex;flex-direction:column;box-shadow:0 18px 50px rgba(7,39,71,.3)}' +
      '#' + SHIP_MODAL_ID + ' .sb-sp-head{display:flex;align-items:center;justify-content:space-between;' +
      'padding:14px 18px;border-bottom:1px solid #e5e5e5;font-family:var(--font-body-family,Roboto,sans-serif);' +
      'font-size:18px;font-weight:600;color:rgb(var(--color-button,7 39 71))}' +
      '#' + SHIP_MODAL_ID + ' .sb-sp-x{background:none;border:0;font-size:28px;line-height:1;cursor:pointer;' +
      'color:#333;padding:0 4px}' +
      '#' + SHIP_MODAL_ID + ' .sb-sp-body{position:relative;flex:1 1 auto;overflow:auto;padding:20px;' +
      '-webkit-overflow-scrolling:touch}' +
      '#' + SHIP_MODAL_ID + ' .sb-sp-body .page-width,#' + SHIP_MODAL_ID + ' .sb-sp-body .page-width--narrow{' +
      'width:100% !important;max-width:100% !important;padding-left:0 !important;padding-right:0 !important}' +
      '#' + SHIP_MODAL_ID + ' .sb-sp-body img{max-width:100%;height:auto}' +
      '#' + SHIP_MODAL_ID + ' .sb-sp-load{padding:40px 0;text-align:center;color:#5b6672;font-size:14px}' +
      '#' + MODAL_ID + '{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;' +
      'justify-content:center;padding:20px;background:rgba(7,39,71,.55);' +
      'font-family:var(--font-body-family,Roboto,Archivo,sans-serif)}' +
      '#' + MODAL_ID + ' .sb-tp-box{background:#fff;border-radius:6px;width:min(720px,96vw);' +
      'max-height:88vh;overflow:auto;padding:26px 26px 20px;box-shadow:0 18px 50px rgba(7,39,71,.28)}' +
      '#' + MODAL_ID + ' h2{margin:0 0 6px;font-family:inherit;font-size:22px;line-height:1.25;' +
      'font-weight:700;color:rgb(var(--color-button,7 39 71));text-transform:none;letter-spacing:0}' +
      '#' + MODAL_ID + ' p.sb-tp-sub{margin:0 0 18px;color:#5b6672;font-size:14px;line-height:1.5}' +
      '#' + MODAL_ID + ' .sb-tp-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(210px,1fr));gap:12px;grid-auto-rows:1fr}' +
      '#' + MODAL_ID + ' button.sb-tp-item{text-align:left;border:1px solid #d5dde5;border-radius:6px;' +
      'background:#fff;padding:14px 15px;cursor:pointer;font-family:inherit;color:rgb(var(--color-button,7 39 71));' +
      'transition:border-color .15s ease,background-color .15s ease}' +
      '#' + MODAL_ID + ' button.sb-tp-item:hover{border-color:rgb(var(--color-button,7 39 71));' +
      'background:rgb(var(--color-background,238 242 247))}' +
      '#' + MODAL_ID + ' .sb-tp-item b{display:block;font-size:15px;line-height:1.35;font-weight:700}' +
      '#' + MODAL_ID + ' .sb-tp-item small{display:block;color:#6b7885;font-size:12.5px;margin-top:3px;font-weight:400}' +
      '#' + MODAL_ID + ' .sb-tp-foot{display:flex;justify-content:space-between;align-items:center;' +
      'margin-top:20px;gap:12px;flex-wrap:wrap}' +
      '#' + MODAL_ID + ' .sb-tp-all{background:none;border:0;font-family:inherit;font-size:14px;font-weight:700;' +
      'color:rgb(var(--color-button,7 39 71));text-decoration:underline;text-underline-offset:3px;' +
      'cursor:pointer;padding:6px 0}' +
      '#' + MODAL_ID + ' .sb-tp-close{border:0;background:rgb(var(--color-button,7 39 71));color:#fff;' +
      'border-radius:999px;padding:11px 26px;font-family:inherit;font-size:14px;font-weight:700;cursor:pointer}' +
      '#' + MODAL_ID + ' .sb-tp-close:hover{opacity:.9}';
    document.head.appendChild(st);
  }

  function open(url) { window.open(url, '_blank', 'noopener'); }

  function close() {
    var m = document.getElementById(MODAL_ID);
    if (m) m.remove();
    document.removeEventListener('keydown', onKey);
  }
  function onKey(e) { if (e.key === 'Escape') close(); }

  function show() {
    if (document.getElementById(MODAL_ID)) return;
    css();
    var back = document.createElement('div');
    back.id = MODAL_ID;
    back.setAttribute('role', 'dialog');
    back.setAttribute('aria-modal', 'true');
    back.setAttribute('aria-label', 'Choose a product');

    var box = document.createElement('div');
    box.className = 'sb-tp-box';
    box.innerHTML =
      '<h2>What are you making?</h2>' +
      '<p class="sb-tp-sub">Pick a product and we will show the designs made for it. ' +
      'It opens in a new tab.</p><div class="sb-tp-grid"></div>' +
      '<div class="sb-tp-foot"><button type="button" class="sb-tp-all">Browse all templates ›</button>' +
      '<button type="button" class="sb-tp-close">Cancel</button></div>';

    var grid = box.querySelector('.sb-tp-grid');
    ITEMS.forEach(function (it) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sb-tp-item';
      b.innerHTML = '<b></b><small></small>';
      b.querySelector('b').textContent = it.label;
      b.querySelector('small').textContent = it.note;
      b.addEventListener('click', function () {
        open(hrefFor(it));
        close();
      });
      grid.appendChild(b);
    });

    box.querySelector('.sb-tp-all').addEventListener('click', function () { open(BASE); close(); });
    box.querySelector('.sb-tp-close').addEventListener('click', close);
    back.addEventListener('click', function (e) { if (e.target === back) close(); });
    document.addEventListener('keydown', onKey);

    back.appendChild(box);
    document.body.appendChild(back);
    var first = box.querySelector('button.sb-tp-item');
    if (first) first.focus();
  }

  /* Every list that carries Help Center (desktop bar, mobile drawer). Falls
     back to Bulk Order in case that label is the one that survives an edit.
     The design center has neither — nothing is inserted there, and the file is
     loaded only for show(). */
  function anchors() {
    var all = document.querySelectorAll('a'), help = [], bulk = [];
    for (var i = 0; i < all.length; i++) {
      var t = (all[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (/^help center$/i.test(t)) help.push(all[i]);
      else if (/^bulk order$/i.test(t)) bulk.push(all[i]);
    }
    return help.length ? help : bulk;
  }

  /* Copy the neighbour whole — anchor, inner span, classes and all — then swap
     the words, so the size and hover behaviour are the bar's own. Colour comes
     from the stylesheet above. */
  function makeLink(ref) {
    var a = ref.cloneNode(true);
    a.setAttribute('href', SHIP_URL);
    a.setAttribute('aria-label', LABEL);
    a.classList.add(LINK_CLASS);
    a.removeAttribute('id');
    var span = a.querySelector('span') || a;
    /* 2026-09-08 V0.0.7: the words sit in an <em> (store's request) — italic, same colour.
       2026-10-12: built from LINE — the hours go in <b class="sb-tp-num"> so they can be red. */
    span.textContent = '';
    var em = document.createElement('em');
    LINE.forEach(function (p) {
      if (typeof p === 'string') { em.appendChild(document.createTextNode(p)); return; }
      if (p.lead) {
        var s = document.createElement('span');
        s.className = 'sb-tp-lead';
        s.textContent = p.lead;
        em.appendChild(s);
        return;
      }
      var b = document.createElement('b');
      b.className = 'sb-tp-num';
      b.textContent = p.n;
      em.appendChild(b);
    });
    span.appendChild(em);
    if (span.hasAttribute && span.hasAttribute('title')) span.setAttribute('title', LABEL);
    /* 2026-10-12: links to the Shipping Details page now — no picker from the bar.
       2026-10-12 (2): a plain left click opens it in the popup below instead. */
    a.addEventListener('click', function (e) {
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      showShip();
    });
    return a;
  }

  /* 2026-10-12 (2): Shipping Details in a popup. Fetches the page and shows its
     main content (header/footer dropped); a failed fetch goes to the page. */
  function shipKey(e) { if (e.key === 'Escape') closeShip(); }
  function closeShip() {
    var m = document.getElementById(SHIP_MODAL_ID);
    if (m) m.remove();
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', shipKey);
  }
  function showShip() {
    if (document.getElementById(SHIP_MODAL_ID)) return;
    css();
    var back = document.createElement('div');
    back.id = SHIP_MODAL_ID;
    back.setAttribute('role', 'dialog');
    back.setAttribute('aria-modal', 'true');
    back.setAttribute('aria-label', SHIP_TITLE);
    back.innerHTML =
      '<div class="sb-sp-box"><div class="sb-sp-head"><span></span>' +
      '<button type="button" class="sb-sp-x" aria-label="Close">&times;</button></div>' +
      '<div class="sb-sp-body"><div class="sb-sp-load">Loading…</div></div></div>';
    back.querySelector('.sb-sp-head span').textContent = SHIP_TITLE;
    back.querySelector('.sb-sp-x').addEventListener('click', closeShip);
    back.addEventListener('click', function (e) { if (e.target === back) closeShip(); });
    document.addEventListener('keydown', shipKey);
    document.body.appendChild(back);
    document.documentElement.style.overflow = 'hidden';

    var body = back.querySelector('.sb-sp-body');
    fetch(SHIP_URL, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var main = doc.querySelector('#MainContent') || doc.querySelector('main') || doc.body;
        var drop = main.querySelectorAll('header, footer, .shopify-section-header, .shopify-section-footer, .announcement-bar');
        for (var i = 0; i < drop.length; i++) drop[i].remove();
        if (!document.getElementById(SHIP_MODAL_ID)) return;
        body.innerHTML = main.innerHTML;
      })
      .catch(function () { closeShip(); window.location.href = SHIP_URL; });
  }

  function place() {
    css();
    anchors().forEach(function (ref) {
      var host = ref.parentNode;
      if (!host) return;
      /* 2026-09-08 V0.0.6: desktop top bar only — the mobile drawer gets no link. */
      if (!ref.closest || !ref.closest('.header-secondary-menu--small')) return;
      /* Clone the whole list item when there is one, so spacing and separators
         come along instead of being guessed at. */
      var isLi = host.tagName === 'LI';
      var scope = isLi ? host.parentNode : host;
      if (!scope || scope.querySelector('.' + LINK_CLASS)) return;

      var link = makeLink(ref);
      if (isLi) {
        var li = host.cloneNode(false);
        li.classList.add(LI_CLASS);
        li.appendChild(link);
        host.parentNode.insertBefore(li, host.nextSibling);
      } else {
        host.insertBefore(link, ref.nextSibling);
      }
    });
  }

  /* The editor's own button opens the same dialog through this. */
  window.__sbTplPicker = { show: show, close: close, items: ITEMS };

  /* 2026-10-03 (2): centred on the bar — the CSS in css() does the centring (left:50% +
     translateX(-50%)), so align() just clears any inline position and lets guard() decide
     whether a narrow window needs it moved. (Until today it was pinned under the main
     menu's «Stickers» item — V0.0.8 2차; the longer wording made that look off-centre.) */
  var GAP = 16;   // 2026-10-03: minimum clear space kept to the links on either side
  function align() {
    var li = document.querySelector('.header-secondary-menu--small .' + LI_CLASS);
    var row = li && li.closest && li.closest('.header-row-inner--small');
    if (!row) return;
    li.style.left = '';
    li.style.transform = '';
    guard(li, row);
  }

  /* 2026-10-03: if the link would run into the phone/email on the right, slide it left —
     but never closer than GAP to Help Center on the left. Neighbours in our own list
     (Bulk Order, Help Center) count as the left side, every other link in the row as the
     right side. Measured fresh every tick after align() has reset the position, so the
     shift never accumulates. */
  function guard(li, row) {
    var a = li.querySelector('.' + LINK_CLASS);
    if (!a || !a.offsetWidth) return;
    var ar = a.getBoundingClientRect(), list = li.parentNode;
    var rightEdge = Infinity, leftEdge = -Infinity;
    var links = row.querySelectorAll('a');
    for (var i = 0; i < links.length; i++) {
      var el = links[i];
      if (li.contains(el) || !el.offsetWidth) continue;
      var er = el.getBoundingClientRect();
      if (list && list.contains(el)) leftEdge = Math.max(leftEdge, er.right);
      else rightEdge = Math.min(rightEdge, er.left);
    }
    var over = ar.right + GAP - rightEdge;
    if (over <= 0) return;
    var room = Math.max(0, ar.left - (leftEdge + GAP));
    var shift = Math.min(over, room);
    if (!shift) return;
    li.style.left = (ar.left - shift - row.getBoundingClientRect().left) + 'px';
    li.style.transform = 'none';
  }

  function start() {
    place(); align();
    /* Drawers and sticky headers re-render their markup, so keep an eye on it
       rather than running once. */
    var t = setInterval(function () { place(); align(); }, 700);
    window.addEventListener('resize', align);
    window.addEventListener('pagehide', function () { clearInterval(t); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
